import { IIndicator } from "../surveyTypes";
const indicatorReducer = (data: any): IIndicator => {
  return {
    id: data.id,
    indicatorName: data.indicator_name,
    indicatorType: data.indicatorType,
  };
};

export default indicatorReducer;
